import React, { useEffect, useState } from 'react'
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { authStore } from '@/context/auth'

// How often to re-check the token's expiry while a protected page sits open.
// isLoggedIn() is already re-checked on every navigation, but a tab left open
// and untouched past the 24h mark wouldn't otherwise notice until the user
// tried to click something — this polls so that tab gets bounced to /login
// on its own, without depending on an API call happening to fail first.
const SESSION_CHECK_INTERVAL_MS = 30_000

/**
 * Wraps all routes that require a logged-in user.
 * If no user is stored, or the JWT has expired, redirects to /login.
 */
const ProtectedRoute: React.FC = () => {
  const location = useLocation()
  const [, forceRecheck] = useState(0)

  useEffect(() => {
    const id = window.setInterval(() => {
      if (!authStore.isLoggedIn()) forceRecheck((t) => t + 1)
    }, SESSION_CHECK_INTERVAL_MS)
    return () => window.clearInterval(id)
  }, [])

  if (!authStore.isLoggedIn()) {
    // Save the page they tried to visit so we can send them back after login
    return <Navigate to="/login" state={{ from: location }} replace />
  }

  return <Outlet />
}

export default ProtectedRoute
